/**
 * Created by JIocb on 23.06.2017.
 */


module Factive.Core {
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    import Armature = dragonBones.Armature;
    import DragonBonesButton = Factive.Game.DragonBonesButton;
    import EventBusConstants = Factive.Core.EventBusConstants;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import Resources = Factive.Game.Resources;
    import ArenaHelper = Arkadium.Game.ArenaHelper;
    import SoundConstants = Factive.Game.SoundConstants;

    export class AchievementPanel extends Panel {

        private _lm:LocalizationManager;
        private _armature: dragonBones.Armature;
        private _time:number;
        private _delayToAutoHide:number = 5000;
        private _arenaHelper: ArenaHelper;

        public get scrimVisible(): boolean {
            return false;
        }

        constructor(dc:DependenciesContainer, name:any) {
            super(dc, name);
            this._lm = this._dc.get("LocalizationManager");
            this._arenaHelper = this._dc.get("ArenaHelper");
        }

        protected build() {
            "use strict";

            this._armature = dragonBones.PixiFactory.factory.buildArmature("Panel_Achievement");
            this.addChild(<PIXI.DisplayObject>this._armature.display);

            var numStars:number = this._data.numStars || 0;
            for(var i = numStars; i<5; i++ )
            {
                this._armature.getSlot("Panel_AchievementStar"+i.toString()).childArmature.getSlot("star_completed").display.visible = false;
            }

            this._time = window.performance.now();

            dragonBones.WorldClock.clock.add(this._armature);
            var scoreView:PIXI.Container = this.createScoreView(this._data.score);
            this._armature.getSlot("Panel_AchScoreContainer").display = scoreView;

            this._armature.animation.play("appear",1);
            PIXI.ticker.shared.add(this.handleTimerTick,this);
            this._armature.display.interactive = true;
            this._armature.display.buttonMode = true;
            this._armature.display.on("pointerup",this.handleTap,this)

            let sm:ISoundManager = <ISoundManager>this._dc.get("SoundManager");
            sm.playSound(SoundConstants.ACHIEVE_COLLECT);

            let ribbonTextureData = Resources.getTextureData("congrad-" + this._arenaHelper.getLocale());
            let ribbonTexture = null;
            if(ribbonTextureData){
                ribbonTexture = new PIXI.Texture(ribbonTextureData.parent.texture, ribbonTextureData.region);
            }
            if(ribbonTexture){
                this._armature.getSlot("congrad").display.texture = ribbonTexture;
            }

            this._calculatePosition();
        };

        private createScoreView(score:number):PIXI.Container
        {
            var rootContainer:PIXI.Container = new PIXI.Container();
            var container:PIXI.Container = new PIXI.Container();
            var str = score.toString();
            var l = str.length;
            var dx:number = 0;

            for(var i:number = 0; i<l; i++)
            {
                var symbolArmature = dragonBones.PixiFactory.factory.buildArmature("ScoreNumber"+str.charAt(i));
                if(symbolArmature)
                {
                    var dobj:any = symbolArmature.display;
                    dobj.x = dx;
                    dx = dobj.x + dobj.width;
                    container.addChild(dobj);
                }
            }

            container.x = -dx*.5;
            rootContainer.addChild(container)
            return rootContainer;
        }

        public handleTap(evt):void
        {
            this._armature.display.off("pointerup",this.handleTap,this);
            this._armature.display.interactive = false;

            PIXI.ticker.shared.remove(this.handleTimerTick,this);

            this.sendEvent(EventBusConstants.EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI);

        };

        public handleTimerTick(data):void
        {
            var delay = window.performance.now() - this._time;
            if(delay>=this._delayToAutoHide)
            {
                this._armature.display.interactive = false;
                this._armature.display.off("pointerup",this.handleTap,this);
                dragonBones.WorldClock.clock.remove(this._armature);
                PIXI.ticker.shared.remove(this.handleTimerTick,this);
                this.sendEvent(EventBusConstants.EVENT_ACHIEVEMENT_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI);
            }
        };

        public reset():void
        {
            if(this._armature)
            {
                PIXI.ticker.shared.remove(this.handleTimerTick,this);

                this.removeChild(<PIXI.DisplayObject>this._armature.display);
                dragonBones.WorldClock.clock.remove(this._armature);
                this._armature.display.interactive = false;
                this._armature.display.off("pointerup",this.handleTap,this)
                this._armature = null;
            }
            super.reset();
        };

        public destroy():void
        {
            PIXI.ticker.shared.remove(this.handleTimerTick,this);
            this._lm = null;
            dragonBones.WorldClock.clock.remove(this._armature);
            this._armature.display.interactive = false;
            this._armature.display.off("pointerup",this.handleTap,this)

            this._armature = null;

            super.destroy();

        }

        protected _calculatePosition(){
            if(this._aspectRatio == "landscape")
            {
                this._armature.display.x = -120 * this._assetScale;
                this._armature.display.y = -125 * this._assetScale;
            }
            else if(this._aspectRatio == "portrait")
            {
                this._armature.display.x = 0;
                this._armature.display.y = -285 * this._assetScale;
            }
        }

        public resize(aspectRatio: string){
            super.resize(aspectRatio);
            if(this._armature == null){
                return;
            }
            this._calculatePosition();
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/AchievementPanel.ts